import { CommonInternalWorkType } from "./CommonInternalWorkType";

enum SpecificAgriculturalContractorInternalWorkType {
    MOUNT = "MOUNT",
    WASH = "WASH",
}

export type AgriculturalContractorInternalWorkType =
    | CommonInternalWorkType
    | SpecificAgriculturalContractorInternalWorkType;
export const AgriculturalContractorInternalWorkType = {
    ...CommonInternalWorkType,
    ...SpecificAgriculturalContractorInternalWorkType,
};
